import { usePlan } from '~/app/plan-context'
import { useActiveProfileId } from '~/entities/profile/model/use-profiles'
import { useResumeSubscription } from '~/entities/subscription/model/use-stripe'
import { managedPlanProfileId } from '~/entities/subscription/plans'
import * as m from '~/paraglide/messages'
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '~/shared/ui/alert-dialog'

interface ResumeSubscriptionDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  businessId: string | undefined
  isCancellation: boolean
}

export function ResumeSubscriptionDialog({
  open,
  onOpenChange,
  businessId,
  isCancellation,
}: ResumeSubscriptionDialogProps) {
  const { ownPlan } = usePlan()
  const profileId = managedPlanProfileId(useActiveProfileId(businessId), ownPlan)
  const resumeSubscription = useResumeSubscription(businessId, profileId)

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            {isCancellation
              ? m.resumeSubscriptionConfirmTitle()
              : m.revertScheduledChangeConfirmTitle()}
          </AlertDialogTitle>
          <AlertDialogDescription>
            {isCancellation
              ? m.resumeSubscriptionConfirmDescription()
              : m.revertScheduledChangeConfirmDescription()}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>{m.cancel()}</AlertDialogCancel>
          <AlertDialogAction onClick={() => resumeSubscription.mutate()}>
            {isCancellation ? m.resumeSubscription() : m.revertScheduledChange()}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
